var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceABid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 752 762",
    style: {
      enableBackground: "new 0 0 752 762"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_1_xA0_Afbeelding_00000039128935402536912490000015170095618718525098_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "206.6,74.7 421.7,250.5 310.8,392.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "428.3,261.1 502.5,422.3 321.4,399.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "468.5,321.6 511.4,415.2 560,275.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "568.4,286.7 589.1,389.6 546.7,348.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "314.2,409.5 495,432.9 298,553  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "300.2,428.9 275.1,642.7 161.5,675.8  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceABid);
export default __webpack_public_path__ + "static/media/PlaceABid.1c9e048a940152d3da9539a044de9e3e.svg";
export { ForwardRef as ReactComponent };